import { lazyLoad } from 'utils/loadable';

export const SystemPage = lazyLoad(
  () => import('./index'),
  module => module.SystemPage,
);
